import React from 'react';
interface TimerProps {
  timeRemaining: number;
  isActive: boolean;
}
const Timer: React.FC<TimerProps> = ({
  timeRemaining,
  isActive
}) => {
  const percentage = timeRemaining / 60 * 100;
  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
  };
  return <div className="text-center" data-id="element-52">
      <div className="text-6xl font-bold mb-4" data-id="element-53">{formatTime(timeRemaining)}</div>
      <div className="h-4 bg-gray-200 rounded-full overflow-hidden mb-6" data-id="element-54">
        <div className="h-full bg-blue-500 transition-all duration-300 ease-in-out" style={{
        width: `${percentage}%`
      }} data-id="element-55"></div>
      </div>
      {isActive && <div className="text-lg font-medium text-gray-600 animate-pulse" data-id="element-56">
          Time remaining...
        </div>}
    </div>;
};
export default Timer;